export enum ShipmentType {
  INBOUND = 'inbound',
  OUTBOUND = 'outbound',
  TRANSFER = 'transfer',
}

export type ShipmentCreateInput = {
  bl_number: string;
  shipment_type: ShipmentType;
  origin_address_id?: string | null;
  destination_address_id?: string | null;
  planned_departure_at?: Date | null;
  planned_arrival_at?: Date | null;
  created_by_user_id: string;
};

export type ShipmentUpdateInput = Partial<ShipmentCreateInput>;

export type Address = {
  id: string;
  address_type: string;
  address_line1: string;
  address_line2?: string;
  city: string;
  region: string;
  postal_code: string;
  country_code: string;
  created_at: string;
};

export type User = {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
};

export type AssetTemplate = {
  id: string;
  name: string;
  description: string;
};

export type AssetInstance = {
  id: string;
  qr_code_value: string;
  instance_number: string;
  current_condition: string;
  current_status: string;
  template?: AssetTemplate;
};

export type ShipmentItem = {
  shipment_id: string;
  asset_instance_id: string;
  expected_stage: string;
  expected_quantity: number;
  package_type: string;
  package_label?: string;
  asset_instance?: AssetInstance;
};

export type ShipmentJob = {
  id: string;
  job_number: string;
  status: 'draft' | 'assigned' | 'in_progress' | 'completed' | 'cancelled' | 'on_hold';
};

export type Shipment = {
  id: string;
  bl_number: string;
  shipment_type: ShipmentType;
  origin_address_id?: string | null;
  destination_address_id?: string | null;
  planned_departure_at?: string | null;
  planned_arrival_at?: string | null;
  actual_departure_at?: string | null;
  actual_arrival_at?: string | null;
  created_at: string;
  updated_at: string;
  created_by_user_id: string;
  origin_address?: Address;
  destination_address?: Address;
  created_by_user?: User;
  asset_instances?: AssetInstance[];
  jobs?: ShipmentJob[];
};

export type ShipmentStats = {
  total: number;
  active: number;
  delivered: number;
  overdue: number;
  byType: {
    inbound: number;
    outbound: number;
    transfer: number;
  };
};
